__turbopack_context__.v({
  "actionsContainer": "ItemDetailContainer-module__sjAQgG__actionsContainer",
  "contentContainer": "ItemDetailContainer-module__sjAQgG__contentContainer",
  "imageContainer": "ItemDetailContainer-module__sjAQgG__imageContainer",
  "itemDetailContainer": "ItemDetailContainer-module__sjAQgG__itemDetailContainer",
  "matchesContainer": "ItemDetailContainer-module__sjAQgG__matchesContainer",
});
